import type { AlertState } from "@/shared/api/models";

/** i18n keys for the state labels shared by the alert feed row + detail panel.
 *  렌더 시점에 `t(STATE_LABEL_KEY[state])` 로 현지화한다. */
export const STATE_LABEL_KEY: Record<AlertState, string> = {
  open: "pages.alerts.filter.open",
  acknowledged: "pages.alerts.filter.acknowledged",
  cleared: "pages.alerts.filter.cleared",
};

/** Badge tone per alert state. */
export function stateBadge(state: AlertState) {
  switch (state) {
    case "open":
      return "danger" as const;
    case "acknowledged":
      return "warning" as const;
    case "cleared":
      return "success" as const;
  }
}
